<nav   class="navbar navbar-expand-lg navbar-light border-bottom bg-gradient topbarnav static-top shadow mb-1 sticky-navbar w-100 p-0 fixed-header position-relative text-icon fixed-top">
  <div class="d-flex align-items-center">
    <!-- Conditionally show sidebar toggle or logo -->
    <i class='bx bx-menu-alt-left d-block d-lg-none fs-2'
       data-bs-toggle="offcanvas"
       href="#offcanvasExample"
       role="button"
       aria-controls="offcanvasExample"></i>

    <div class="d-flex align-items-center ms-2">
      <!-- Logo -->
      <a class="navbar-brand d-flex align-items-center d-none d-md-flex pointer" href="/home">
        <img :src="$clientLogo" class="img-fluid logo pointer ms-4" alt="Logo" />
      </a>
 
  <!-- Mobile Logo -->
      <a class="navbar-brand d-flex align-items-center d-flex d-md-none mobile-logo" :class="{ 'd-none': showSearch }" href="/home">
        <img :src="$clientLogo" class="img-fluid" alt="Logo" />
      </a>
    </div>
  </div>
  

  
  <ul class="navbar-nav d-flex flex-row ms-auto mb-0 align-items-center">
    <li class="nav-item text-xxs mx-2">
      <a class="text-muted" href="/home">
<i class="bi bi-house-door fs-2 text-dark"></i>
      </a>
    </li>
    <a  class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xxs fw-500 d-none d-md-block" @click="toggleMenu">
      <i class="bi bi-grid-fill fs-3"></i>
    </a>
    <NotificationDropdown class="d-none d-xl-block me-3 mt-2" />
    <li class="nav-item tex-xxs mx-2">

  <!-- ================= MOBILE (OFFCANVAS) ================= -->
  <div class="d-block d-lg-none">

    <!-- Profile trigger -->
    <div v-if="profile_data.profile_files && profile_data.profile_files.length"
         class="me-2 profile-list-avatar mt-2 me-auto"
         style="cursor: pointer;"
         data-bs-toggle="offcanvas"
         data-bs-target="#profileOffcanvas"
         aria-controls="profileOffcanvas">
      <img :src="profile_data.profile_files[0].file.file_url"
           alt="Profile Image"
           class="d-block rounded-5 profile-image">
    </div>

    <span v-else
          style="cursor: pointer;"
          data-bs-toggle="offcanvas"
          data-bs-target="#profileOffcanvas"
          aria-controls="profileOffcanvas">
      <img src="@/assets/images/user.png" class="w-50" alt="User Icon">
    </span>

    <!-- Offcanvas -->
    <div class="offcanvas offcanvas-end small-offcanvas"
         tabindex="-1"
         id="profileOffcanvas">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title">Profile</h5>
        <button type="button"
                class="btn-close"
                data-bs-dismiss="offcanvas"></button>
      </div>

      <div class="offcanvas-body">
        <ul class="list-unstyled mb-0">
          <li><a class="dropdown-item" href="/profile">Profile</a></li>
          <li>
            <a class="dropdown-item" href="#" @click.prevent="log_out">
              Logout
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>


  <!-- ================= DESKTOP (DROPDOWN) ================= -->

  <div class="dropdown d-none d-lg-block">
          <a href="/profile" class="d-flex align-items-center justify-content-center text-decoration-none">
          <div v-if="profile_data.profile_files"
              class="profile-list-avatar d-flex align-items-center justify-content-center text-dark text-xxs fw-500 pointer mt-2 me-1">
              <img
                  :src="profile_data.profile_files[0].file.file_url"
                  alt="Profile Image"
                  class="d-block rounded-5 profile-image">
          </div>

          <div v-else class="d-flex align-items-center justify-content-center text-dark text-xxs fw-500 pointer">
              <i class="bi bi-person-circle fs-2 text-dark"></i>
          </div>
        </a>
      </div>

</li>

  </ul>
    <div v-if="showMenu"  class="menu-dropdown ms-0 me-5 mt-2 shadow">
    <MenuSideBar />
  </div>
</nav>

<Sidebar variant="mobile" />

<StickyNav/>
